function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

async function updateCartCount() {
  const header = document.querySelector('header');
  const counter = header.querySelector('span[data-cart-count]');

  const response = await fetch(`${window.routes.cart_url}.js`);
  const json = await response.json();
  counter.textContent = json.item_count;
}

(function openExternalLinksInNewTab() {
  [...document.links].forEach((link) => {
    if (link.hostname !== window.location.hostname) {
      link.target = '_blank';
      link.rel = 'noreferrer noopener';
    }
  });
})();

class NimbiHeader extends window.HTMLElement {
  constructor() {
    super();

    this.expanded = false;
    this.toggle = this.querySelector('[data-menu-toggle]');
    this.close = this.querySelector('[data-menu-close]');
    this.menu = this.querySelector('[data-menu]');
    this.menuTray = this.querySelector('.header-main-menu');
  }

  connectedCallback() {
    this.toggle.addEventListener('click', this.toggleMenu.bind(this));
    this.close.addEventListener('click', this.closeMenu.bind(this));

    this.makeFocusable();

    if (window.innerWidth >= 990) {
      this.makeFocusable();
    } else if (!this.expanded) {
      this.makeUnfocusable();
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) {
        this.makeFocusable();
      } else if (!this.expanded) {
        this.makeUnfocusable();
      }
    });

    const media = window.matchMedia('(min-width: 990px)');

    if (!media.matches) {
      this.moveMenuOutside();
    }

    media.addEventListener('change', (e) => {
      if (e.matches) {
        this.moveMenuInside();
      } else {
        this.moveMenuOutside();
      }
    });
  }

  moveMenuOutside() {
    const entry = this.querySelector('header.difference');

    if (entry) {
      entry.before(this.menuTray);
    }
  }

  moveMenuInside() {
    const entry = this.querySelector('.header-mobile-toggle');

    if (entry) {
      entry.after(this.menuTray);
    }
  }

  toggleMenu() {
    if (this.expanded) {
      this.expanded = false;
      this.makeUnfocusable();
      document.body.style.overflow = 'auto';
    } else {
      this.expanded = true;
      this.makeFocusable();
      this.close.focus();
      document.body.style.overflow = 'hidden';
    }

    this.toggle.setAttribute('aria-expanded', this.expanded);
    this.menuTray.setAttribute('aria-hidden', !this.expanded);
  }

  closeMenu() {
    this.expanded = false;
    this.makeUnfocusable();
    this.toggle.setAttribute('aria-expanded', this.expanded);
    this.menuTray.setAttribute('aria-hidden', !this.expanded);
    document.body.style.overflow = 'auto';
  }

  makeFocusable() {
    this.menu.querySelectorAll('[tabindex]').forEach((el) => {
      el.setAttribute('tabindex', '0');
    });

    this.trapFocus(this.menu);
  }

  makeUnfocusable() {
    this.menu.querySelectorAll('[tabindex]').forEach((el) => {
      el.setAttribute('tabindex', '-1');
    });

    this.untrapFocus(this.menu);
  }

  trapFocus(element) {
    const focusableEls = element.querySelectorAll(
      'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
    );
    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];

    element.addEventListener('keydown', (e) => {
      const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    });
  }

  untrapFocus(element) {
    element.removeEventListener('keydown', this.trapFocus);
  }
}

customElements.define('nav-header', NimbiHeader);

/* ---------------------------------------------------------
   NIMBI UK GWP CART GUARD
   Any Nimbi product = eligible for exactly 1 free Headband
--------------------------------------------------------- */

async function enforceNimbiFreeGift() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const hasEligibleProduct = cart.items.some(
      (item) =>
        !(
          item.product_title === 'NIMBI Headband' &&
          item.properties &&
          String(item.properties['_Free gift']) === 'true'
        )
    );

    const giftItems = cart.items.filter(
      (item) =>
        item.product_title === 'NIMBI Headband' &&
        item.properties &&
        String(item.properties['_Free gift']) === 'true'
    );

    const updates = {};

    giftItems.forEach((gift) => {
      // No qualifying product = remove gift
      if (!hasEligibleProduct) {
        updates[gift.key] = 0;
        return;
      }

      // Maximum quantity 1
      if (gift.quantity !== 1) {
        updates[gift.key] = 1;
      }
    });

    if (!Object.keys(updates).length) return;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates }),
    });

    window.location.reload();
  } catch (error) {
    console.warn('[NIMBI GWP] Could not enforce gift rules', error);
  }
}

// Check whenever cart page loads
document.addEventListener('DOMContentLoaded', enforceNimbiFreeGift);

// Re-check after quantity/remove interactions
document.addEventListener(
  'change',
  debounce(() => {
    enforceNimbiFreeGift();
  }, 500)
);

document.addEventListener(
  'click',
  debounce((event) => {
    if (
      event.target.closest(
        'button, quantity-input, cart-remove-button, [href*="/cart/change"]'
      )
    ) {
      enforceNimbiFreeGift();
    }
  }, 500)
);